export class Purchase {
  id: string;
  organization_id: string;
  branch_id: string;
  date_time: string;
  price_offer: string;
  customer_id: string;
  customer_type:string;
  customer_name:string;
  supplier_id: string;
  supplier_name:string;
  supplier_tax_num: string;
  purchase_type:string;
  delegate_type:string;
  delegate_id:string;
  delegate_name: string;
  items_from_branch_id: string;
  row_id: string;
  start_date: string;
  end_date: string;
  post_status: string;
  total_free: string;
  customer_cash: string;
  paid: string;
  disc_type:string;
  disc_value:string;
  remain:string;
  import_date:string;
  time:string;
  supplier_inv_num: string;
  supplier_inv_date: string;
  date_of_supply: string;
  inv_details:string;
  inv_payment_details:string;
  last_on_behalf_of:string;
  collecting_customs_tax:any;
  showDeletedOnly: boolean;
  year:any;
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pro/purchases/purchases.ts